module.exports = __webpack_public_path__ + "static/media/amusement(4).924e2dc3.PNG";